import { Component } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {SessionService} from "./shared/session.service";
import {ErreurModalComponent} from "./shared/erreurmodal/erreur.component";
import * as Bowser from "bowser";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(private translateService: TranslateService, private sessionService: SessionService, private dialog: MatDialog){
    translateService.setDefaultLang('fr');
    translateService.use('fr');
    this.checkBrowser();
  }

  private checkBrowser(){
    if(!this.sessionService.getBadBrowserPopinOpen()) {
      const browser = Bowser.getParser(window.navigator.userAgent);
      console.log('[' + browser.getBrowserName() + '] [' + browser.getBrowserVersion() + ']');

      const isValidBrowser = browser.satisfies({
        ie: ">=11",
        safari: ">=7",
        chrome: ">=56",
        firefox: ">=50",
        edge: ">=13",
      });

      if(!isValidBrowser) {
        this.openNavigateurModalErreur();
      }

      this.sessionService.setBadBrowserPopinOpen(true);
    }
  }

  private openNavigateurModalErreur(){
    let dialogRef: MatDialogRef<ErreurModalComponent>;
    dialogRef = this.dialog.open(ErreurModalComponent);
    dialogRef.componentInstance.message = "MAUVAIS_NAVIGATEUR";
    dialogRef.componentInstance.titre = "MAUVAIS_NAVIGATEUR";
    dialogRef.componentInstance.codeErreur = 0;
  }
}
